angular.module('bizmetryApp').controller('ConnectionResultDialogController', function (
  $scope, $mdDialog, title, data, isError
) {
  $scope.title = title;
  $scope.isError = isError;
  $scope.closeDialog = function () {
    $mdDialog.hide();
  };

  if (!isError && data) {
    $scope.properties = [
      { name: 'Database Product', value: data.databaseProductName },
      { name: 'Version', value: data.databaseProductVersion },
      { name: 'Major Version', value: data.databaseMajorVersion },
      { name: 'Minor Version', value: data.databaseMinorVersion },
      { name: 'Driver', value: data.driverName },
      { name: 'Driver Version', value: data.driverVersion },
      { name: 'Connection URL', value: data.url, isCode: true }
    ];
  } else {
    $scope.properties = [{ name: 'Error', value: data }];
  }
});
